import { DatoImage } from '@components/image/DatoImage';
import { InfoFragment } from '@graphql/generated';
import Image from 'next/image';

type Props = {
  infos: InfoFragment[];
};

export const ProductInfos = ({ infos = [] }: Props) => {
  return (
    <div className="product-hero__info-list">
      {infos.map((info, index) => (
        <div className="product-hero__info-item" key={index}>
          <div className="product-info">
            <div className="product-info__icon">
              {info.icon?.responsiveImage && <DatoImage data={info.icon.responsiveImage} />}
              {
                // SVG images does not have responsiveImage valorized
                !info.icon?.responsiveImage && info.icon?.url && (
                  <Image src={info.icon.url} alt={info.label} />
                )
              }
            </div>
            <div className="product-info__content">
              <div className="product-info__title">{info.label}</div>
              <div className="product-info__text">{info.value}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
